// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Button = require("@mui/material/Button").default;

function MM_cmp_click_counter(props) {
  var match = React.useState(function () {
        return 0;
      });
  var setCnt = match[1];
  return React.createElement(Button, {
              onClick: (function (param) {
                  Curry._1(setCnt, (function (prev) {
                          return prev + 1 | 0;
                        }));
                }),
              children: Caml_option.some("" + props.title + ". Clicked: " + String(match[0]) + "")
            });
}

var make = MM_cmp_click_counter;

exports.make = make;
/* react Not a pure module */
